(function () {
  'use strict';
  const originals = new WeakMap();
  function update() {
    const size = window.LeavysProductSize?.current().size || '';
    document.querySelectorAll('[data-product-explore]').forEach((component) => {
      const option = component.dataset.sizeOption;
      const selected = option ? size : '';
      component.querySelectorAll('[data-explore-link]').forEach((link) => {
        if (!originals.has(link)) originals.set(link, link.getAttribute('href'));
        const url = new URL(originals.get(link), location.origin);
        if (selected) {
          url.searchParams.set(`filter.v.option.${option}`, selected);
          url.searchParams.set('filter.v.availability', '1');
        }
        link.href = url.pathname + url.search + url.hash;
      });
      const status = component.querySelector('[data-explore-size]');
      status.hidden = !selected;
      status.textContent = selected ? component.dataset.sizeMessage.replace('__size__', selected) : '';
    });
  }
  document.addEventListener('leavys:size-change', update);
  document.addEventListener('shopify:section:load', update);
  update();
})();
